import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'

// Configuration pour un rendu optimal
const root = ReactDOM.createRoot(document.getElementById('root'))

// Mode Strict pour un développement de qualité
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)